import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getErrorMessage(error, defaultMessage = 'An error occurred') {
  if (!error) return defaultMessage;
  
  const detail = error.response?.data?.detail;
  const message = typeof error.message === 'string' ? error.message.trim() : '';
  
  // Handle Pydantic string error
  if (typeof detail === 'string') return detail;
  
  // Handle Pydantic validation errors (array of objects)
  if (Array.isArray(detail)) {
    return detail.map(err => err.msg).join(', ');
  }

  // Handle wrapped object detail payloads
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message.trim();
    if (typeof detail.error === 'string' && detail.error.trim()) return detail.error.trim();
  }
  
  // Fallback to JS/runtime error message
  if (message) return message;
  
  return defaultMessage;
}
